import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { ReadRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';
import { ConfigGuard } from '@occc-app/App/guards';
import { Can } from '@occc-app/App/PolicyBasedAccessControl';
import UnauthorizedPage from '@occc-app/routes/Unauthorized';

type RetailerNetworkMyStoresPageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkMyStoresPageGuard = ({
  children,
}: RetailerNetworkMyStoresPageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <ConfigGuard isFeatureEnabled={(config) => config.retailerConnect.enabled}>
      <Can I={ReadRetailerNetwork({ uuid: networkId })} fallback={<UnauthorizedPage />}>
        {children}
      </Can>
    </ConfigGuard>
  );
};
